import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import "fontsource-roboto";
import "./assets/boxicons-2.0.7/css/boxicons.min.css";
import "./assets/css/grid.css";
import "./assets/css/theme.css";
import "./assets/css/index.css";
import "./assets/css/main.css";

import Layout from "./components/layout/Layout";
import store from "./redux/store";
import AlertBox from "./components/alertBox/alertBox";
import Login from "./pages/Login/Login";
import LoadableApp from "./LoadableApp";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import AppRoutes from "./components/Routes";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import Products from "./pages/Products";
import Trips from "./pages/Trips";
import Brokers from "./pages/Brokers";
import InvoiceList from "./pages/Sales/InvoiceList";
import Invoice from "./pages/Invoice";
import ProductManagement from "./pages/Product/ProductManagement";
import Unauthorized from "./pages/Unauthorized";
import Users from "./pages/Users";
import Stock from "./pages/Stock";
import LogOut from "./pages/LogOut";
import Barcode from "./pages/Barcode";
import ItemPriceUpdate from "./pages/Product/product_priceUpdate";
import StockReport from "./pages/Reports/StockReport";
import PaymentDue from "./pages/Billing/PaymentDue";
import ProductStepper from "./pages/Product/product_entry";
import ProductImageAndVideoUpdate from "./pages/Product/productImageAndVideoUpdate";
import CreateStorageBox from "./pages/StorageBox/CreateStorageBox";
import BanksManagement from "./pages/Banks/BanksManagement";
import PriceUpdate from "./pages/Product/PriceUpdate";

document.title = "Shimla gem management";



const rootId = document.getElementById("root");

const { user, isLogin } = store.getState().userReducer;

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter>
          <Routes>
            {/* public routes */}
            <Route path="/login" element={<Login />} />

            {/* private routes */}
            <Route element={<Layout />}>
              <Route element={<PrivateRoute allowedRoles={["admin"]} />}>
                {/* <Route path="/" exact element={<Dashboard />} /> */}
                <Route path="/customers" element={<Customers />} />
                <Route path="/banks-management" element={<BanksManagement />} />
             
              </Route>

              <Route element={<PrivateRoute allowedRoles={["admin", "basic"]} />} >
                <Route path="/" exact element={<Dashboard />} />
                <Route path="/invoice" element={<Invoice />} />
                <Route path="/invoice-list" element={<InvoiceList />} />
                <Route path="/logout" element={<LogOut />} />
                
                <Route path="/items" element={<Products />} />
                <Route path="/storageBox" element={<CreateStorageBox />} />
                <Route path="/new-item" element={<ProductStepper />} />
                <Route path="/suppliers" element={<Suppliers />} />
                <Route path="/brokers" element={<Brokers />} />
                <Route path="/trip" element={<Trips />} />
                <Route path="/users" element={<Users />} />
                <Route path="/product-management" element={<ProductManagement />} />
                <Route path="/stock" element={<Stock />} />
                <Route path="/barcode" element={<Barcode />} />
                <Route path="/reports" element={<StockReport />} />
                <Route path="/item-price-update" element={<PriceUpdate />} />
                <Route path="/item-image-update" element={<ProductImageAndVideoUpdate />} />
              </Route>

              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route
                path="*"
                element={
                  <div className="flex flex-col h-full justify-center items-center text-3xl font-extrabold text-white">
                    <h2>Not Found </h2>
                    <Link to={"/"}> Dashboard</Link>
                  </div>
                }
              />
            </Route>
            <Route path="/app-billing" element={<PaymentDue />} />

            <Route
              path="*"
              element={
                <div className="bg-black flex flex-col h-full justify-center items-center text-3xl font-extrabold text-white">
                  <h2>Not Found </h2>
                  <Link to={"/"}> Login</Link>
                </div>
              }
            ></Route>
          </Routes>
        </BrowserRouter>

        <AlertBox />
      </LocalizationProvider>
    </React.StrictMode>
  </Provider>,

  rootId
);
module.hot.accept();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// if (module.hot && process.env.NODE_ENV === "development") {
//   module.hot.accept("./App", () => {
//     const NextApp = require("./LoadableApp").default;
//     ReactDOM.render(
//       <React.StrictMode>
//         <LoadableApp />
//       </React.StrictMode>,
//       rootId
//     );
//   });
// }
